

import RequestAbstract from "../abstract";

export default class WalletWallets extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/wallet/wallets";
    }
}

